export default __webpack_public_path__ + "media/zurb/img/legacy/icons/feeder/chop-9e27f691a298cfda6c9b98ec43b00fed.png";